module.exports = __webpack_public_path__ + "img/saishianpai-icon-5.1f86b910.png";